import React from 'react';

import { Tooltip } from '@bringg/react-components';
import { useRoutesMonitoringTranslations } from '@bringg-frontend/monitoring';

import { DetailedCellProps } from '../../hooks/use-columns';

import styles from './fulfillment-cell.module.scss';

const FulfillmentCell = ({ row }: DetailedCellProps) => {
	const t = useRoutesMonitoringTranslations();
	const { id, fulfillment, tasks_count } = row;
	const { completed, partial_completed, canceled } = fulfillment;
	const remain = tasks_count - (completed + partial_completed + canceled);

	return (
		<>
			{tasks_count > 0 && (
				<Tooltip
					title={`${completed} ${t.completed} / ${partial_completed} ${t.partialCompleted} / ${canceled} ${t.canceled} / ${remain} ${t.remain}`}
					overlayStyle={{ maxWidth: 400 }}
				>
					<div className={styles.fulfillmentBar} data-test-id={`fulfillment-cell-${id}`}>
						<div className={styles.completed} style={{ width: `${(completed / tasks_count) * 100}%` }} />
						<div
							className={styles.partialCompleted}
							style={{ width: `${(partial_completed / tasks_count) * 100}%` }}
						/>
						<div className={styles.canceled} style={{ width: `${(canceled / tasks_count) * 100}%` }} />
						<div
							className={styles.remain}
							style={{
								width: `${(remain / tasks_count) * 100}%`
							}}
						/>
					</div>
				</Tooltip>
			)}
		</>
	);
};

export default FulfillmentCell;
